import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

interface Args {
  toDate?: Date;
  fromDate?: Date;
  deviceId?: string;
  enabled?: boolean;
}

export function useTripsByDeviceAndDateRange({ deviceId, fromDate, toDate, enabled }: Args) {
  const { activeSessionId, geotabClient } = useGeotabClient();

  return useQuery({
    queryKey: ["trips", activeSessionId, { deviceId, fromDate, toDate }],

    queryFn: ({ signal }) => {
      if (!deviceId) {
        return Promise.resolve([]);
      }

      return geotabClient.get(
        "Trip",
        {
          deviceSearch: { id: deviceId },
          fromDate,
          toDate,
        },
        1000,
        signal,
      );
    },

    enabled
  });
}
